import React, { useState, useEffect } from 'react';
import { History, Shield } from 'lucide-react';
import { AuditLog } from '../../types';

export const AdminAudit: React.FC = () => {
  const [logs, setLogs] = useState<AuditLog[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchLogs = async () => {
    try {
      const res = await fetch('/api/admin/audit');
      if (res.ok) {
        const data = await res.json() as any;
        setLogs(data.logs || []);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-bold text-gray-900">Journal d’Audit</h2>
        <p className="text-xs text-gray-500">Historique horodaté et immuable des actions administratives</p>
      </div>

      <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
        <table className="w-full text-left text-xs">
          <thead className="bg-gray-50 border-b text-gray-500 font-semibold uppercase tracking-wider">
            <tr>
              <th className="p-4">Date</th>
              <th className="p-4">Admin</th>
              <th className="p-4">Action</th>
              <th className="p-4">Cible</th>
              <th className="p-4">Détails</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 font-mono">
            {logs.length === 0 ? (
              <tr>
                <td colSpan={5} className="p-8 text-center text-gray-400 font-sans">
                  Aucun événement d'audit enregistré.
                </td>
              </tr>
            ) : (
              logs.map(l => (
                <tr key={l.id} className="hover:bg-gray-50/50">
                  <td className="p-4 text-gray-500">
                    {new Date(l.created_at).toLocaleDateString()} {new Date(l.created_at).toLocaleTimeString()}
                  </td>
                  <td className="p-4 font-bold text-gray-900">{l.admin_user}</td>
                  <td className="p-4">
                    <span className="inline-flex px-2 py-0.5 bg-gray-100 text-gray-800 rounded-md font-bold text-[10px]">
                      {l.action}
                    </span>
                  </td>
                  <td className="p-4 text-gray-700">{l.target_type} {l.target_id ? `(${l.target_id})` : ''}</td>
                  <td className="p-4 text-gray-500 max-w-xs truncate text-[11px]">
                    {l.details_json || '—'}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
